module.exports = __webpack_public_path__ + "img/service-light.5f00a95c.png";